export default "__VITE_ASSET__cYk7zLHZ__"